import { Grid, Box, Typography } from "@mui/material";

const AlunoFotoListV2 = ({ listaAF = [] }) => {
  if (!listaAF.length) {
    return (
      <Typography color="text.secondary" sx={{ mt: 3 }}>
        Nenhuma foto disponível.
      </Typography>
    );
  }

  return (
    <Grid
      container
      direction="row"
      alignContent="flex-start"
      spacing={3}
      sx={{ my: "20px" }}
    >
      {listaAF.map((af) => (
        <Grid key={af?.codigo} size={{ xs: 12, md: 6, lg: 4 }}>
          {af?.foto ? (
            <Box
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src={af.foto}
                alt={`Foto de ${af.aluno.nome}`}
                loading="lazy"
                sx={{ height: 200, cursor: "pointer" }}
              />
              <Typography variant="body2" mt={1}>
                {af.aluno.codAlunoEscola} — {af.aluno.nome}
              </Typography>
            </Box>
          ) : (
            <>
              <Typography color="text.secondary">
                Nenhuma imagem selecionada
              </Typography>
              <Typography variant="body2" mt={1}>
                {af?.aluno?.codAlunoEscola} — {af?.aluno?.nome}
              </Typography>
            </>
          )}
        </Grid>
      ))}
    </Grid>
  );
};

export default AlunoFotoListV2;
